import React from 'react';
import { withRouter } from 'react-router-dom';
import { CheckOutlined, CloseOutlined, WarningOutlined } from '@ant-design/icons';
import { Row, Col, List, Button } from 'antd';
import { UnpaidFeeMultipleResultForm } from './';
import './UnpaidFeeResultForm.less';

class UnpaidFeeResultForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filteredInfo: null,
      sortedInfo: null,
      sortedFees: this.props.unpaidFees,
    };
    this.sortByGodkendt = this.sortByGodkendt.bind(this);
    this.sortByAfvist = this.sortByAfvist.bind(this);
  }

  /**
   * Returns the user to the search page.
   */
  handleBack = () => {
    this.props.history.push('/search');
  };

  /**
   * Sorts by approved results
   */
  sortByGodkendt = () => {
    let sorted = this.props.unpaidFees.sortBy((a, b) => {
      const value = a.get('Value');
      if (value === 2) return 1;
      if (value === 1 || value === 3) return -1;
    });
    this.setState({ sortedFees: sorted });
  };

  /**
   * Sorts by rejected results
   */
  sortByAfvist = () => {
    let sorted = this.props.unpaidFees.sortBy((a, b) => {
      const value = a.get('Value');
      if (value === 2) return -1;
      if (value === 1 || value === 3) return 1;
    });
    this.setState({ sortedFees: sorted });
  };

  /**
   * Determines weather the result is accepted, rejected or is a warning.
   * @param value is the value code of the result
   * @returns {string} a string matching part of a css style.
   */
  determineResultColor(value) {
    switch (value) {
      case 1:
      case 3:
        return 'accepted';
      case 2:
        return 'rejected';
      default:
        return 'warning';
    }
  }

  /**
   * Creates the correct layout based on the search parameters.
   * @param unpaidFee is the result of the search
   * @param colorCode is the color to be shown
   * @returns {*} the body layout based on the result.
   */
  getSearchedValue(unpaidFee, colorCode) {
    let text = '';
    let icon = '';
    if (unpaidFee.get('AKRnumber') != null) {
      text = 'AKR Nr.: ' + unpaidFee.get('AKRnumber');
    } else if (unpaidFee.get('CPRnumber') != null) {
      text = 'CPR Nr.: ' + unpaidFee.get('CPRnumber');
    } else if (unpaidFee.get('CVRnumber') != null) {
      text = 'CVR Nr.: ' + unpaidFee.get('CVRnumber');
    } else if (unpaidFee.get('Firstname') != null && unpaidFee.get('Lastname') != null) {
      text = 'Navn: ' + unpaidFee.get('Firstname') + ' ' + unpaidFee.get('Lastname');
    } else if (unpaidFee.get('Lastname') != null) {
      text = 'Virksomhedsnavn: ' + unpaidFee.get('Lastname');
    } else {
      text = 'ERROR';
    }

    switch (colorCode.toLowerCase()) {
      case 'accepted':
        icon = <CheckOutlined />;
        break;

      case 'rejected':
        icon = <CloseOutlined />;
        break;

      default:
        icon = <WarningOutlined />;
        break;
    }

    return (
      <Row type={'flex'} align={'middle'}>
        <Col span={12}>
          <label>{text}</label>
        </Col>
        <Col span={11}>
          <span className='float-right'>{icon}</span>
        </Col>
      </Row>
    );
  }

  render() {
    let resultWaitToRender = 100;

    return (
      <Row className={'unpaidfees-form'}>
        <Col span={24}>
          <Row>
            <Col span={24}>
              <div className={'search-label'}>
                <label>Svar fra DFIM</label>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Row type={'flex'} align={'middle'}>
                <Col span={12}>
                  <Button.Group>
                    <Button onClick={this.sortByAfvist}>Afvist</Button>
                    <Button onClick={this.sortByGodkendt}>Godkendt</Button>
                  </Button.Group>
                </Col>
                <Col span={12}>
                  <label className={'label-link float-right'} onClick={this.handleBack}>
                    Tilbage
                  </label>
                </Col>
              </Row>
              <List className={'spacing-top'} size={'large'}>
                {this.state.sortedFees.map((entry, i) => {
                  const colorCode = this.determineResultColor(entry.get('Value'));
                  const cardTitle = this.getSearchedValue(entry, colorCode);
                  return (
                    <UnpaidFeeMultipleResultForm
                      wait={(resultWaitToRender += 100)}
                      key={i}
                      unpaidFee={entry}
                      colorCode={colorCode}
                      cardTitle={cardTitle}
                    />
                  );
                })}
              </List>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default withRouter(UnpaidFeeResultForm);
